// extracted by mini-css-extract-plugin
export default {"survey":"LifecycleSurveys_survey__dGpwP"};